import type { Roadmap_Item } from "@/domains/admin/roadmap/types/roadmap-types";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useRoadmapContext } from "../context/useRoadmapContext";
import { deleteRoadmapItem } from "../services/api";

export const useDeleteRoadmapItem = () => {
  const qc = useQueryClient();
  const { setItems } = useRoadmapContext();

  return useMutation<unknown, Error, string>({
    mutationFn: deleteRoadmapItem,

    onError: () => {
      // Fehlgeschlagen? → komplettes Refetch / Rollback
      void qc.invalidateQueries({ queryKey: ["roadmapItems"] });
    },

    onMutate: (id) => {
      // optimistisch sofort aus dem React-Query-Cache entfernen
      qc.setQueryData<Roadmap_Item[]>(["roadmapItems"], (old) =>
        old ? old.filter((it) => it.id !== id) : old,
      );

      // und parallel im lokalen Context-Store herausnehmen
      setItems((items) => items.filter((it) => it.id !== id));
    },

    onSuccess: (_data, id) => {
      // Sicherheitshalber refetchen …
      void qc.invalidateQueries({ queryKey: ["roadmapItems"] });

      // … und Context-Store erneut synchronisieren
      setItems((items) => items.filter((it) => it.id !== id));
    },
  });
};
